import React from 'react';
import { DiabetesPageTemplate } from './DiabetesPageTemplate';
import { diabetesImages } from './diabetesPageData';

const TypesOfDiabetes = () => {
  return (
    <DiabetesPageTemplate
      eyebrow="Diabetes Basics"
      title="What Are The Types Of Diabetes?"
      intro="Diabetes is a chronic condition in which glucose regulation is impaired. Although the major forms share high blood sugar as a common feature, they differ in cause, age of onset, and management."
      heroSummary="There are three major types of diabetes discussed here, each requiring a different care strategy."
      heroImage={diabetesImages.typesImg}
      heroAlt="Diagram showing different types of diabetes"
      sections={[
        {
          title: 'How Diabetes Develops',
          paragraphs: [
            'Diabetes is a chronic condition resulting in high blood sugar levels, because of the impaired glucose regulation in the body. After having food, our digestive system breaks down the food into glucose and other nutrients that are released into blood. Insulin is a key hormone produced by the pancreas and responsible for glucose uptake from the blood to the cells for their functioning. Thus, glucose serves as a fuel for the human body and is required for all voluntary processes like playing, working, etc. and involuntary processes like heart functioning, digestion, blood circulation, etc. Absence of insulin or decreased sensitivity of the body cells to insulin results in diabetes.',
            'There are three major types of diabetes, each having a different cause and management strategy as given below:',
          ],
          image: diabetesImages.causeImg,
          imageAlt: 'Causes and pathways behind diabetes',
          imageCaption: 'The type depends on whether the main issue is insulin absence, insulin resistance, or pregnancy-related glucose imbalance.',
        },
        {
          title: 'The Major Types',
          columns: [
            {
              title: 'Type 1 Or Insulin-Dependent Diabetes',
              text: "Type 1 diabetes is an important and less prevalent type of diabetes that develops most often at a relatively younger age (children or young adults), and so also called juvenile diabetes. It is an auto-immune condition where the body's own immune system destroys the insulin producing cells in pancreas, thus resulting in lack of insulin in the body. Management of people with type 1 diabetes requires lifelong insulin supplementation, controlled diet and exercise to help them maintain sugar control.",
            },
            {
              title: 'Type 2 Or Non-Insulin Dependent Diabetes',
              text: 'Type 2 diabetes is the highly prevalent form of diabetes that affects mostly adults or older age groups. In this specific diabetic condition, the insulin is produced in very low amounts and is insufficient. Both hereditary and lifestyle factors such as poor eating behaviour, sedentary lifestyle, low physical activity, being overweight or obese, play a role in the development of type 2 diabetes.',
            },
            {
              title: 'Gestational Diabetes',
              text: 'A third type of diabetes, gestational diabetes, is a temporary condition that occurs usually during the second trimester of pregnancy, and disappears after delivery in most cases. Even though temporary, it still requires monitoring and proper medical guidance to protect both mother and baby.',
            },
          ],
        },
      ]}
    />
  );
};

export default TypesOfDiabetes;
